import React from 'react';
import SearchResult from '../../shared/SearchResults';

export default function CsmResolved() {
  return <SearchResult statuses={['RSLV']} pageType="Resolved" />;
}
